import { colors } from './colors';

export const shadows = {
    xs: `0px 1px 2px 0px ${colors['shadow-black']}`,
    sm: `0px 1px 3px 0px ${colors['shadow-black']}`,
    md: `0px 4px 6px -1px ${colors['shadow-black']}, 0px 2px 4px -2px ${colors['shadow-black']}`,
    lg: `0px 10px 15px -3px ${colors['shadow-black']}, 0px 4px 6px -4px ${colors['shadow-black']}`,
};
